import { AssetLookup } from '@reshub/model';

export class AssetInfoDto extends AssetLookup {}
